const Footer = () => {
  return (
    <footer className="bg-gray-100 text-center py-4 text-sm text-gray-500">
      © {new Date().getFullYear()} Job Miner. Built with ❤️ by Hadush.
    </footer>
  );
};

export default Footer;
